// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bitter:wght@700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

iframe {
  display: none !important;
}

html,
body {
  height: 100%;
  overflow-x: hidden;
}

main {
  min-height: 300px;
}

footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/** 
Sidebar **/

.wrapper {
  display: flex;
  align-items: stretch;
}

.square-transformed {
  transform: scaleX(0.5);
}

#logoNoLogo {
  transition: .4s opacity;
}

.sidebar-btn {
  padding: .4em;
  margin: .4em;
  margin-right: 0;
  background-color: rgba(255, 255, 255, 0);
  border: none;
}

.sidebar-btn:focus {
  outline: none;
}

input {
  outline: none!important;
}

#sidebar {
  position: absolute;
  /* display:inline; */
  /* float:left; */
  top: 0;
  min-width: 4em;
  max-width: 250px;
  width: 250px;
  height: 100vh;
  min-height: 90vh;
  background: none;
  color: #333;
  transition: width .4s ease-in-out;
  border-right: 1px solid rgba(0, 0, 0, .1);
  z-index: 999;
  outline: hidden;
  margin-left: -250px;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, .5);
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  /* Konqueror HTML */
  /* Old versions of Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.sidebar-stretched {
  width: 4em !important;
}

#sidebar .sidebar-header {
  padding: 20px;
  background: #6d7fcc;
}

#sidebar ul.components {
  /* margin-top: 1.3em; */
}

#sidebar ul li {
  border-bottom: 1px rgba(0, 0, 0, .1) solid;
  padding-top: .5em;
  padding-bottom: .5em;
}

#sidebar ul li.hbg-blue:hover {
  background-image: linear-gradient(to right, rgba(54, 54, 247, 0.2), rgba(255, 0, 0, 0));
}

#sidebar ul li.hbg-red:hover {
  background-image: linear-gradient(to right, rgba(247, 54, 54, 0.2), rgba(255, 0, 0, 0));
}

#sidebar ul li.hbg-orange:hover {
  background-image: linear-gradient(to right, rgba(247, 147, 54, 0.2), rgba(255, 0, 0, 0));
}

#sidebar ul li.hbg-yellow:hover {
  background-image: linear-gradient(to right, rgba(255, 251, 41, 0.3), rgba(255, 0, 0, 0));
}

#sidebar ul li.hbg-green:hover {
  background-image: linear-gradient(to right, rgba(54, 247, 86, 0.2), rgba(255, 0, 0, 0));
}

#sidebar ul li.hbg-waterblue:hover {
  background-image: linear-gradient(to right, rgba(42, 255, 219, 0.26), rgba(255, 0, 0, 0));
}

#sidebar ul p {
  color: #fff;
  padding: 10px;
}

#sidebar ul li a {
  padding: 10px;
  padding-left: 1.1em;
  font-size: 1.1em;
  display: block;
  color: black;
}

#sidebar ul li.active>a,
a[aria-expanded="true"] {
  color: darkslategrey;
  background: #ddd;
}

.menu-item-text-col {
  opacity: 1;
  transition: .3s opacity;
}

.menu-item-text-col label {
  margin-bottom: 0 !important;
}

.menu-item-text-col-deactivated {
  opacity: 0;
}

ul ul a {
  font-size: 0.9em !important;
  padding-left: 30px !important;
  background: #ddd;
}

#sidebar.active {
  margin-left: 0;
}

a[data-toggle="collapse"] {
  position: relative;
}

.dropdown-toggle::after {
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

.toast {
  margin: auto;
}

@media (max-width: 768px) {
  #sidebar {
    margin-left: -250px;
  }

  #sidebar.active {
    margin-left: 0;
  }
}

/** End
      Sidebar **/

a {
  cursor: pointer
}

a label {
  cursor: pointer;
}

nav {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  /* Konqueror HTML */
  /* Old versions of Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.edit-input-border {
  border: 0;
  border-bottom: 1px #000 solid;
  background: rgba(0, 0, 0, 0);
}

.edit-input-border:focus {
  outline: none;
}

.calendar-disabled {
  opacity: 0.5;
  pointer-events: none;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  /* Konqueror HTML */
  /* Old versions of Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.wrap {
  white-space: pre-wrap;
  /* CSS3 */
  white-space: -moz-pre-wrap;
  /* Firefox */
  white-space: -pre-wrap;
  /* Opera <7 */
  white-space: -o-pre-wrap;
  /* Opera 7 */
  word-wrap: break-word;
  /* IE */
}

.react-calendar {
  margin: auto
}

.dmd-table-head {
  background: rgba(40, 40, 40, 1);
  color: rgba(250, 250, 250, 1);
  border-radius: 10px 10px 0 0;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  text-transform: uppercase;

  box-shadow: 0 0 4px 0 rgb(0, 0, 0) inset, 0 0 4px 1px rgb(0, 0, 0);
  display: flex;
}

.dmd-table-head-title {
  border-right: 1px solid rgba(100, 100, 100, 1);
  padding: 1em;
  display: inline-block;
}

.dmd-table-head-title:last-of-type {
  border-right: 0;
}

/* .dmd-table-body {
  background: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  font-family: 'Montserrat', sans-serif;
  font-weight: 300;
  text-transform: uppercase;

  display: flex;
  box-shadow: 0 0 2px 0 rgb(0, 0, 0) inset, 0 0 2px .5px rgb(0, 0, 0);
}

.dmd-table-body:last-of-type {
  border: 1px solid rgba(100, 100, 100, 1);
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.dmd-table-body-col {
  padding: 1em 1em;
  display: flex;
  justify-content: space-between;
  position: relative;
  border-right: 1px solid rgba(100, 100, 100, 1);
}

.dmd-table-body-col:nth-child(1), .dmd-table-head-title:nth-child(1){
  width: 50%;
}
.dmd-table-body-col:nth-child(2), .dmd-table-head-title:nth-child(2){
  width: 30%;
}

.dmd-table-body-col:nth-of-type(3), .dmd-table-head-title:nth-child(3){
  width: 20%;
  border-right: 0;
}
.dmd-table-body-col label {
  width: 100%;
}
.dmd-table-body-col i{
  font-size: 140%;
}

#guest-comp .dmd-table-body-col:nth-child(1), #guest-comp .dmd-table-head-title:nth-child(1){
  width: 80%;
}
#guest-comp .dmd-table-body-col:nth-child(2), #guest-comp .dmd-table-head-title:nth-child(2){
  width: 20%;
}

.dmd-table-body-col.user-list {
  padding-bottom: 1.2em;
}

.dmd-table-body-col button {
  height: 3em;
  width: 50px;
  color: rgba(100,100,100,.2);
  border:0;
  border-radius: 8px;
}
.dmd-table-body-col button.green {
  color: rgba(10,205,10,1);
} */


#gear1 {
  font-size: 1.4em;
  color: black !important;
}

button .spin:hover {
  animation: spin 4s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}


#accessPoint {
  text-align: center;
}

#accessPointHead {
  border: 1px solid rgba(100, 100, 100, 1);
  padding: 1em;
  background: rgba(40, 40, 40, 1);
  color: white;
  display:flex;
  justify-content: space-between;
  align-items: center;
}

#accessPointHead > div{
  display: flex;
  justify-content: space-between;
  align-items: center; 
}

#accessPointHead input {
  font-weight: bold;
  background: rgba(40, 40, 40, 1);
  border: 0;
  color: white;
  margin-left: .5em;
}

#accessPointHead button{
  text-transform: uppercase;
  font-weight: bold;
  color: rgba(255,255,255, 1);
}

#accessPointDetails {
  display:flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 1.3%;
  
}
#accessPointDetails button{
  width: 100%;
  padding: 1em 0;
  background: rgba(255,255,255,1);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border:0;
  box-shadow: 0 0 1px 2px rgba(240,240,255,.5);
  text-transform: uppercase;
  color: rgba(0,0,0,.9);
  font-size: 90%;
  outline:none;
}
#accessPointDetails button.selected{
  box-shadow: 0 0 1px 2px rgba(55,55,250,.8);
  background: rgba(55,55,250,.8);
  font-weight: bold;
  color:white;
}
#accessPointDetails button:active{
  background: rgba(155,155,180,.3);
}


.accessPointDetail {
  background: rgba(0, 0, 0, .1);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom: .5em solid rgba(0, 0, 0, .1);
  border-right: .2em solid rgba(0, 0, 0, .1);
  padding-top: 1em;
  padding-bottom: 1em;
}

.accessPointDetail .row {
  margin-bottom: 1em;
}

.device-key-label-on,
.device-key-label-off {
  display: block;
  font-size: 1.2vh;
  font-weight: bold;
}

.device-key {
  display: inline-block;
}

.modal-dialog .btn-close {
  border: 0;
  background: none;

}

label.title-details {
  font-weight: bold;
  border-top: 1px dashed rgba(20, 20, 20, .8);
  width: 100%;
  padding: .5em;
  margin-top: .5em;
  font-size: 110%;
  color:rgb(30,30,30);
}

#pulse-mode button:first-child{
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
#pulse-mode button:last-child{
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

@media only screen and (max-width: 600px) {

  /* .dmd-table-body-col {
    display: flex;
    justify-content: space-between;
  }

  .dmd-table-body-col button {
    position: inherit !important;
    left: 0;
  } */
}


#report {
  padding-bottom: 8em;
}

.section-title {
  text-align: center;
  font-size: 150%;
  margin-bottom: 1em;
  color:white;
  text-shadow: 0px 1px rgba(0, 150, 150,.5);
  background: rgba(15,15,15);
  padding: .4em;
  box-shadow: 0 0 2px 4px rgba(15,15,15);
  display: flex;
  justify-content: center;
  align-items: center;
}
.section-title img {
  width: 25px;
}
.section-title img, .section-title svg {
  margin-right: .3em;
}

.success{
  color: rgba(10,180,10,1);
}
.danger{
  color: rgba(180,0,0,1);
}


#reportHeadTools{
  margin-top: .5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1em;
}

#reportHeadTools button{
  display: flex;
  align-items: center; 
  justify-content: space-between;
  flex-direction: column;
  background: rgba(0,0,0,0);
  border: 0;
  font-weight: bold;
  text-transform: uppercase;
  outline: none;
}
#reportHeadTools button:focus {
  outline: none;
}

#reportHeadTools button label{
  font-size: 12px;
}
#reportHeadTools button svg{
  font-size: 28px;
}
#reportInfoText{
  font-size: 14px;
}
#reportBody{
  margin: .2em;
}
#reportBody label{
  margin-left: .4em;
  color: rgba(0,0,0,.9);
}

#exportBtn {
  color: rgba(10,80,0,.9);
}
#refreshBtn{
  color: rgba(10,20,130,.9);
}
#deleteBtn{
  color: rgba(190,20,10,.9);
}
#line{
  width: 100%;
  border-bottom: 1px solid rgba(0,0,0,.1);
  margin: 1em 0;
}`, "",{"version":3,"sources":["webpack://./css/app.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;UACU;;AAEV;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,MAAM;EACN,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,WAAW;EAEX,mBAAmB;EAEnB,4BAA4B;EAE5B,2BAA2B;EAC3B,iBAAiB;EACjB;gFAC8E;AAChF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;gBACgB;;AAEhB;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,WAAW;EAEX,mBAAmB;EAEnB,4BAA4B;EAE5B,2BAA2B;EAC3B,iBAAiB;EACjB;gFAC8E;AAChF;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,WAAW;EAEX,mBAAmB;EAEnB,4BAA4B;EAE5B,2BAA2B;EAC3B,iBAAiB;EACjB;gFAC8E;AAChF;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE;AACF;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,qCAAqC;EACrC,iBAAiB;EACjB,yBAAyB;;EAEzB,kEAAkE;EAClE,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmEG;;;AAGH;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EAGE,kCAAkC;AACpC;;AAcA;EACE;IAEE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;;AAElB;AACA;EACE,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;EAC/B,QAAQ;EACR,4CAA4C;EAC5C,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;AACA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;;;AAGA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;;AAElB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;EAEE;;;;;;;;KAQG;AACL;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,0BAA0B;EAC1B,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,uCAAuC;EACvC,aAAa;AACf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Bitter:wght@700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n}\n\niframe {\n  display: none !important;\n}\n\nhtml,\nbody {\n  height: 100%;\n  overflow-x: hidden;\n}\n\nmain {\n  min-height: 300px;\n}\n\nfooter {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/** \nSidebar **/\n\n.wrapper {\n  display: flex;\n  align-items: stretch;\n}\n\n.square-transformed {\n  transform: scaleX(0.5);\n}\n\n#logoNoLogo {\n  transition: .4s opacity;\n}\n\n.sidebar-btn {\n  padding: .4em;\n  margin: .4em;\n  margin-right: 0;\n  background-color: rgba(255, 255, 255, 0);\n  border: none;\n}\n\n.sidebar-btn:focus {\n  outline: none;\n}\n\ninput {\n  outline: none!important;\n}\n\n#sidebar {\n  position: absolute;\n  /* display:inline; */\n  /* float:left; */\n  top: 0;\n  min-width: 4em;\n  max-width: 250px;\n  width: 250px;\n  height: 100vh;\n  min-height: 90vh;\n  background: none;\n  color: #333;\n  transition: width .4s ease-in-out;\n  border-right: 1px solid rgba(0, 0, 0, .1);\n  z-index: 999;\n  outline: hidden;\n  margin-left: -250px;\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, .5);\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n.sidebar-stretched {\n  width: 4em !important;\n}\n\n#sidebar .sidebar-header {\n  padding: 20px;\n  background: #6d7fcc;\n}\n\n#sidebar ul.components {\n  /* margin-top: 1.3em; */\n}\n\n#sidebar ul li {\n  border-bottom: 1px rgba(0, 0, 0, .1) solid;\n  padding-top: .5em;\n  padding-bottom: .5em;\n}\n\n#sidebar ul li.hbg-blue:hover {\n  background-image: linear-gradient(to right, rgba(54, 54, 247, 0.2), rgba(255, 0, 0, 0));\n}\n\n#sidebar ul li.hbg-red:hover {\n  background-image: linear-gradient(to right, rgba(247, 54, 54, 0.2), rgba(255, 0, 0, 0));\n}\n\n#sidebar ul li.hbg-orange:hover {\n  background-image: linear-gradient(to right, rgba(247, 147, 54, 0.2), rgba(255, 0, 0, 0));\n}\n\n#sidebar ul li.hbg-yellow:hover {\n  background-image: linear-gradient(to right, rgba(255, 251, 41, 0.3), rgba(255, 0, 0, 0));\n}\n\n#sidebar ul li.hbg-green:hover {\n  background-image: linear-gradient(to right, rgba(54, 247, 86, 0.2), rgba(255, 0, 0, 0));\n}\n\n#sidebar ul li.hbg-waterblue:hover {\n  background-image: linear-gradient(to right, rgba(42, 255, 219, 0.26), rgba(255, 0, 0, 0));\n}\n\n#sidebar ul p {\n  color: #fff;\n  padding: 10px;\n}\n\n#sidebar ul li a {\n  padding: 10px;\n  padding-left: 1.1em;\n  font-size: 1.1em;\n  display: block;\n  color: black;\n}\n\n#sidebar ul li.active>a,\na[aria-expanded=\"true\"] {\n  color: darkslategrey;\n  background: #ddd;\n}\n\n.menu-item-text-col {\n  opacity: 1;\n  transition: .3s opacity;\n}\n\n.menu-item-text-col label {\n  margin-bottom: 0 !important;\n}\n\n.menu-item-text-col-deactivated {\n  opacity: 0;\n}\n\nul ul a {\n  font-size: 0.9em !important;\n  padding-left: 30px !important;\n  background: #ddd;\n}\n\n#sidebar.active {\n  margin-left: 0;\n}\n\na[data-toggle=\"collapse\"] {\n  position: relative;\n}\n\n.dropdown-toggle::after {\n  display: block;\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n}\n\n.toast {\n  margin: auto;\n}\n\n@media (max-width: 768px) {\n  #sidebar {\n    margin-left: -250px;\n  }\n\n  #sidebar.active {\n    margin-left: 0;\n  }\n}\n\n/** End\n      Sidebar **/\n\na {\n  cursor: pointer\n}\n\na label {\n  cursor: pointer;\n}\n\nnav {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n.edit-input-border {\n  border: 0;\n  border-bottom: 1px #000 solid;\n  background: rgba(0, 0, 0, 0);\n}\n\n.edit-input-border:focus {\n  outline: none;\n}\n\n.calendar-disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n.wrap {\n  white-space: pre-wrap;\n  /* CSS3 */\n  white-space: -moz-pre-wrap;\n  /* Firefox */\n  white-space: -pre-wrap;\n  /* Opera <7 */\n  white-space: -o-pre-wrap;\n  /* Opera 7 */\n  word-wrap: break-word;\n  /* IE */\n}\n\n.react-calendar {\n  margin: auto\n}\n\n.dmd-table-head {\n  background: rgba(40, 40, 40, 1);\n  color: rgba(250, 250, 250, 1);\n  border-radius: 10px 10px 0 0;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: bold;\n  text-transform: uppercase;\n\n  box-shadow: 0 0 4px 0 rgb(0, 0, 0) inset, 0 0 4px 1px rgb(0, 0, 0);\n  display: flex;\n}\n\n.dmd-table-head-title {\n  border-right: 1px solid rgba(100, 100, 100, 1);\n  padding: 1em;\n  display: inline-block;\n}\n\n.dmd-table-head-title:last-of-type {\n  border-right: 0;\n}\n\n/* .dmd-table-body {\n  background: rgb(255, 255, 255);\n  color: rgb(0, 0, 0);\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 300;\n  text-transform: uppercase;\n\n  display: flex;\n  box-shadow: 0 0 2px 0 rgb(0, 0, 0) inset, 0 0 2px .5px rgb(0, 0, 0);\n}\n\n.dmd-table-body:last-of-type {\n  border: 1px solid rgba(100, 100, 100, 1);\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n  border-radius: 10px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.dmd-table-body-col {\n  padding: 1em 1em;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  border-right: 1px solid rgba(100, 100, 100, 1);\n}\n\n.dmd-table-body-col:nth-child(1), .dmd-table-head-title:nth-child(1){\n  width: 50%;\n}\n.dmd-table-body-col:nth-child(2), .dmd-table-head-title:nth-child(2){\n  width: 30%;\n}\n\n.dmd-table-body-col:nth-of-type(3), .dmd-table-head-title:nth-child(3){\n  width: 20%;\n  border-right: 0;\n}\n.dmd-table-body-col label {\n  width: 100%;\n}\n.dmd-table-body-col i{\n  font-size: 140%;\n}\n\n#guest-comp .dmd-table-body-col:nth-child(1), #guest-comp .dmd-table-head-title:nth-child(1){\n  width: 80%;\n}\n#guest-comp .dmd-table-body-col:nth-child(2), #guest-comp .dmd-table-head-title:nth-child(2){\n  width: 20%;\n}\n\n.dmd-table-body-col.user-list {\n  padding-bottom: 1.2em;\n}\n\n.dmd-table-body-col button {\n  height: 3em;\n  width: 50px;\n  color: rgba(100,100,100,.2);\n  border:0;\n  border-radius: 8px;\n}\n.dmd-table-body-col button.green {\n  color: rgba(10,205,10,1);\n} */\n\n\n#gear1 {\n  font-size: 1.4em;\n  color: black !important;\n}\n\nbutton .spin:hover {\n  -webkit-animation: spin 4s linear infinite;\n  -moz-animation: spin 4s linear infinite;\n  animation: spin 4s linear infinite;\n}\n\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n\n#accessPoint {\n  text-align: center;\n}\n\n#accessPointHead {\n  border: 1px solid rgba(100, 100, 100, 1);\n  padding: 1em;\n  background: rgba(40, 40, 40, 1);\n  color: white;\n  display:flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n#accessPointHead > div{\n  display: flex;\n  justify-content: space-between;\n  align-items: center; \n}\n\n#accessPointHead input {\n  font-weight: bold;\n  background: rgba(40, 40, 40, 1);\n  border: 0;\n  color: white;\n  margin-left: .5em;\n}\n\n#accessPointHead button{\n  text-transform: uppercase;\n  font-weight: bold;\n  color: rgba(255,255,255, 1);\n}\n\n#accessPointDetails {\n  display:flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 1.3%;\n  \n}\n#accessPointDetails button{\n  width: 100%;\n  padding: 1em 0;\n  background: rgba(255,255,255,1);\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border:0;\n  box-shadow: 0 0 1px 2px rgba(240,240,255,.5);\n  text-transform: uppercase;\n  color: rgba(0,0,0,.9);\n  font-size: 90%;\n  outline:none;\n}\n#accessPointDetails button.selected{\n  box-shadow: 0 0 1px 2px rgba(55,55,250,.8);\n  background: rgba(55,55,250,.8);\n  font-weight: bold;\n  color:white;\n}\n#accessPointDetails button:active{\n  background: rgba(155,155,180,.3);\n}\n\n\n.accessPointDetail {\n  background: rgba(0, 0, 0, .1);\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-bottom: .5em solid rgba(0, 0, 0, .1);\n  border-right: .2em solid rgba(0, 0, 0, .1);\n  padding-top: 1em;\n  padding-bottom: 1em;\n}\n\n.accessPointDetail .row {\n  margin-bottom: 1em;\n}\n\n.device-key-label-on,\n.device-key-label-off {\n  display: block;\n  font-size: 1.2vh;\n  font-weight: bold;\n}\n\n.device-key {\n  display: inline-block;\n}\n\n.modal-dialog .btn-close {\n  border: 0;\n  background: none;\n\n}\n\nlabel.title-details {\n  font-weight: bold;\n  border-top: 1px dashed rgba(20, 20, 20, .8);\n  width: 100%;\n  padding: .5em;\n  margin-top: .5em;\n  font-size: 110%;\n  color:rgb(30,30,30);\n}\n\n#pulse-mode button:first-child{\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n#pulse-mode button:last-child{\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n@media only screen and (max-width: 600px) {\n\n  /* .dmd-table-body-col {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .dmd-table-body-col button {\n    position: inherit !important;\n    left: 0;\n  } */\n}\n\n\n#report {\n  padding-bottom: 8em;\n}\n\n.section-title {\n  text-align: center;\n  font-size: 150%;\n  margin-bottom: 1em;\n  color:white;\n  text-shadow: 0px 1px rgba(0, 150, 150,.5);\n  background: rgba(15,15,15);\n  padding: .4em;\n  box-shadow: 0 0 2px 4px rgba(15,15,15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.section-title img {\n  width: 25px;\n}\n.section-title img, .section-title svg {\n  margin-right: .3em;\n}\n\n.success{\n  color: rgba(10,180,10,1);\n}\n.danger{\n  color: rgba(180,0,0,1);\n}\n\n\n#reportHeadTools{\n  margin-top: .5em;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1em;\n}\n\n#reportHeadTools button{\n  display: flex;\n  align-items: center; \n  justify-content: space-between;\n  flex-direction: column;\n  background: rgba(0,0,0,0);\n  border: 0;\n  font-weight: bold;\n  text-transform: uppercase;\n  outline: none;\n}\n#reportHeadTools button:focus {\n  outline: none;\n}\n\n#reportHeadTools button label{\n  font-size: 12px;\n}\n#reportHeadTools button svg{\n  font-size: 28px;\n}\n#reportInfoText{\n  font-size: 14px;\n}\n#reportBody{\n  margin: .2em;\n}\n#reportBody label{\n  margin-left: .4em;\n  color: rgba(0,0,0,.9);\n}\n\n#exportBtn {\n  color: rgba(10,80,0,.9);\n}\n#refreshBtn{\n  color: rgba(10,20,130,.9);\n}\n#deleteBtn{\n  color: rgba(190,20,10,.9);\n}\n#line{\n  width: 100%;\n  border-bottom: 1px solid rgba(0,0,0,.1);\n  margin: 1em 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
